
import { handleError, openNotificationWithIcon } from "appRedux/actions/Common";
import { config } from "constants/config";
import { useTheme } from "context/themeContext";
import { Formik } from "formik";
import React, { useState } from "react";
import DOMPurify from "dompurify";
import {
  Button,
  Form,
  FormGroup,
  InputGroup,
  Input,
  FormFeedback,
} from "reactstrap";
import LinkComponent from "routes/LinkComponent";
import { redirectDashboard } from "routes/RedirectRoutes";
import { useOperatorNavigate } from "utils/navigationHelper";
import api from "appRedux/api";

const TransactionEmail = () => {
  const [loading, setLoading] = useState(false);
  const { colorTheme, logoUrl, whiteLabelName } = useTheme();
  const navigate = useOperatorNavigate()
  const redirectLoginPage = () => {
  navigate("/transactions/login")
  }

  const submitHandler = async (data) => {
    setLoading(true);

   
    
    try {
      await api.post(
        `/report/otp/${data?.email}`,
        {}, // body (empty in this case)
        config.tokenUrl // will be used as baseURL and validated
      );
    
      setLoading(false);
      openNotificationWithIcon(
        "OTP successfully sent to your mail",
        "check your mail and login"
      );
      setTimeout(() => {
        navigate("/transactions/login");
      }, 2000);
    } catch (error) {
      console.error("OTP Generation Error:", error);
      handleError(error?.message || "Network Error");
    } finally {
      setLoading(false);
    }
    
  };

  return (
    <div className="main-section">
      <div className="topBar">
             <img
               src={DOMPurify.sanitize(logoUrl)}
               alt={`${whiteLabelName} logo`}
               style={{
                 width: "80px",
                 height: "auto",
                 objectFit: "fit",
                 maxHeight: "80px",
               }}
             />
             <div
               onClick={redirectDashboard}
               style={{ color: colorTheme, cursor: "pointer" }}
             >
               Go Home
             </div>
           </div>
      <main className="dashboard__main">
        <div className="dashboard_header">
          <h3 style={{ textAlign: "center", marginTop: "10px" }}>
            Get transport tickets transaction history.
          </h3>
        </div>
      </main>
      <div className="transaction_form_ontainer">
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={(values) => {
            const submitEmail = {
              email: values.email,
            };
            submitHandler(submitEmail);
          }}
          validate={(values) => {
            const errors = {};
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          
            if (!values.email) {
              errors.email = "Email is required";
            } else if (!emailRegex.test(values.email)) {
              errors.email = "Enter a valid email address";
            }
          
            return errors;
          }}
          render={({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            isValidating,
          }) => (
            <Form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <FormGroup>
                <InputGroup className="mb-3">
                  <header className="mb-2">
                    <center>
                      Input your email address, you will recieve OTP to access
                      your transaction history
                    </center>
                  </header>

                  <Input
                    style={{
                      height: "42px",
                      borderRadius: "1px",
                      fontSize: "0.9rem",
                      width: "100%",
                    }}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    invalid={!!(errors.email && touched.email)}
                  />
                  {errors.email && touched.email && (
                    <FormFeedback>{errors.email}</FormFeedback>
                  )}
                </InputGroup>
              </FormGroup>

              <Button
                block
                style={{
                  height: "45px",
                  borderRadius: "1px",
                  fontSize: "0.9rem",
                  background: colorTheme,
                }}
                className="secondary-btn"
                onClick={handleSubmit}
                disabled={
                  isValidating ||
                  !values.email ||
                  loading ||
                  Object.keys(errors).length > 0
                }
              >
                {loading ? "Sending email..." : "Submit"}
              </Button>
              <br />
              <center>
                <p>
                  {" "}
                  Already received OTP?{" "}
                  <span style={{cursor:"pointer"}} onClick={redirectLoginPage}>Login</span>
                </p>
              </center>
            </Form>
          )}
        />
      </div>
    </div>
  );
};
export default TransactionEmail;
